import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useSocket } from "../../../Context/SocketContext";
import { useSelector } from "react-redux";

export const ChatContext = createContext();

export function useChatContext() {
  return useContext(ChatContext);
}

export default function ChatContextProvider({ children }) {
  const socket = useSocket();
  const { isSocketConnected, user } = useSelector((state) => state.authInfo);

  //   console.log(user);
  //   console.log(isSocketConnected);

  const INITIAL_CHAT_THREAD = useMemo(() => {
    return {
      isError: false,
      isLoading: true,
      data: [],
    };
  }, []);

  const [chatRoom, setChatRoom] = useState({});

  const [chatThread, setChatThread] = useState(INITIAL_CHAT_THREAD);

  useEffect(() => {
    if (!isSocketConnected) return;

    socket.emit("_getChatThreads");
  }, [isSocketConnected]);

  useEffect(() => {
    if (isSocketConnected) {
      socket.on("getChatThreads_", (data) => {
        console.log(data);
        setChatThread((prev) => {
          return {
            ...prev,
            isLoading: false,
            data: data?.data || [],
          };
        });
      });
    }

    return () => {
      if (isSocketConnected) {
        socket.dispose("getChatThreads_");
      }
    };
  }, [isSocketConnected]);

  useEffect(() => {
    if (!isSocketConnected) return;

    socket.on("receivedMessage_", (res) => {
      const data = res?.data || {};
      setChatThread((prev) => {
        return {
          ...prev,
          data: prev?.data.map((item) => {
            if (item.chat_room_slug !== data?.chat_room_slug) return item;
            return {
              ...item,
              message: {
                ...item?.message,
                message_type: data?.message_type,
                message: data?.message,
                createdAt: data?.message_timestamp,
              },
              unread_message_count:
                chatRoom?.slug === data?.chat_room_slug
                  ? item?.unread_message_count
                  : item?.unread_message_count + 1,
            };
          }),
        };
      });
    });
  }, [isSocketConnected, chatRoom]);

  const resetMessageCount = (chat_room_slug) => {
    setChatThread((prev) => {
      return {
        ...prev,
        data: prev?.data.map((item) => {
          if (item.chat_room_slug !== chat_room_slug) return item;
          return {
            ...item,
            unread_message_count: 0,
          };
        }),
      };
    });
  };

  const updateLastMessagePayload = (data) => {
    setChatThread((prev) => {
      return {
        ...prev,
        data: prev?.data.map((item) => {
          if (item.chat_room_slug !== data?.chat_room_slug) return item;
          return {
            ...item,
            message: {
              ...item?.message,
              message_type: data?.message_type,
              message: data?.message,
              createdAt: data?.message_timestamp,
            },
          };
        }),
      };
    });
  };

  return (
    <ChatContext.Provider
      value={{
        chatThreads: chatThread,
        chatRoom,
        setChatRoom,
        resetMessageCount,
        updateLastMessagePayload,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
}
